"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _InventoryConfiguration_1 = require("./_InventoryConfiguration");
exports._InventoryConfigurationList = {
    type: "list",
    flattened: true,
    member: {
        shape: _InventoryConfiguration_1._InventoryConfiguration
    }
};
//# sourceMappingURL=_InventoryConfigurationList.js.map